<template lang="pug">
  v-container
    v-layout(column)
      contact-sync-configuration(
        :email="email"
      )
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import ContactSyncConfiguration from './ContactSyncConfiguration';

export default {
  components: {
    ContactSyncConfiguration,
  },
  props: {
    email: {
      type: String,
      default: '',
    }
  },
  methods: {
    handleClose() {
      this.$emit('input');
    },
  },
};
</script>
